import 'ag-grid-community/styles/ag-grid.css';
import ReactDOM from 'react-dom/client';
import 'reset-css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<App />);
